export const updateStartMondayBack = (instance, startOnMonday) => {
  if (Number(user.settings?.start_monday) === Number(startOnMonday)) return;
  if (user.settings) {
    user.settings.start_monday = startOnMonday;
  }

  instance.callEvent('onUpdateUserNotificationSettings', [{ data: { start_monday: startOnMonday } }]);
};

export default {};
